<template>
   <div class="choose-currency">
    <select v-if="$route.name !== 'global'" name="currency" v-model="currency" @change="selectCurrency">
      <option v-if="getStoreConfig() && !isNotUseStoreCurrency(getStoreConfig().currency)" :value="null">{{ getStoreConfig().currency }}</option>
      <option
        v-for="rate in (currencyRates)"
        :value="rate.toCurrency"
        :key="rate.id"
      >
      {{ rate.toCurrency }}
      </option>
    </select>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { getItemByLocalStorage, setLocalStorage } from '@/utils/localStorage'
import localStorageKey from '@/constants/localStorageKey'

export default {
  name: 'UiDropdownCurrency',
  components: { },
  props: {
    currencyRates: {
      type: Array,
      default: () => []
    },
    getCurrencies: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      currency: null
    }
  },
  methods: {
    ...mapActions({
      setCustomizeData: 'report/setCustomizeData'
    }),
    getStoreConfig () {
      return getItemByLocalStorage(localStorageKey.STORE_CONFIG)
    },
    isNotUseStoreCurrency (currency) {
      if (currency && currency.length && this.currencyRates && this.currencyRates.length > 0) {
        const existCurrency = this.currencyRates.find(currencyItem => currency === currencyItem.toCurrency)
        return !!existCurrency
      }
      return false
    },
    selectCurrency () {
      const currencyRate = (this.currencyRates || []).find(rate => rate.toCurrency === this.currency)
      if (currencyRate) {
        const currencySelected = this.getCurrencies.find(currencyItem => this.currency === currencyItem.code)
        const symbol = currencySelected.currency_symbol || this.currency
        var isBaseCurrency = this.getStoreConfig().currency && this.isNotUseStoreCurrency(this.getStoreConfig().currency) && this.currency === this.getStoreConfig().currency
        setLocalStorage(localStorageKey.CURRENT_CURRENCY, { ...currencyRate, symbol, rate: isBaseCurrency ? 1 : currencyRate.rate })
      }
      if (!this.currency && getItemByLocalStorage(localStorageKey.CURRENT_CURRENCY)) {
        const storeConfig = getItemByLocalStorage(localStorageKey.STORE_CONFIG)
        const currencySelected = this.getCurrencies.find(currencyItem => storeConfig?.currency === currencyItem.code)
        const symbol = currencySelected.symbol
        setLocalStorage(localStorageKey.CURRENT_CURRENCY, {
          fromCurrency: storeConfig?.currency,
          toCurrency: storeConfig?.currency,
          rate: 1,
          symbol
        })
      }
      this.$emit('getData')
    }
  },
  created () {
    if (getItemByLocalStorage(localStorageKey.CURRENT_CURRENCY)) {
      this.currency = getItemByLocalStorage(localStorageKey.CURRENT_CURRENCY).toCurrency
    } else {
      if (this.currencyRates && this.currencyRates.length > 0) {
        const currencyRate = this.currencyRates[0]
        if (currencyRate) {
          const storeConfig = getItemByLocalStorage(localStorageKey.STORE_CONFIG)
          const currencySelected = this.getCurrencies?.find(currencyItem => storeConfig?.currency === currencyItem.code)
          if (currencySelected) {
            const symbol = currencySelected.symbol
            setLocalStorage(localStorageKey.CURRENT_CURRENCY, {
              fromCurrency: storeConfig?.currency,
              toCurrency: storeConfig?.currency,
              rate: 1,
              symbol
            })
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  select {
    padding: 0 15px;
    margin: 0;
    height: 39px;
    min-width: 140px;
    outline: none;
    border-radius: 4px;
    border: 1px solid #818181;
    background-color: #fff;
  }
</style>
